var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: { x: "7", y: "6", width: "11", height: "11", fill: _vm.color }
      }),
      _c("path", {
        attrs: {
          d:
            "M18.5408 4.17001L13.0408 2.11001C12.4708 1.90001 11.5408 1.90001 10.9708 2.11001L5.47078 4.17001C4.41078 4.57001 3.55078 5.81001 3.55078 6.94001V15.04C3.55078 15.85 4.08078 16.92 4.73078 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4508 5.81001 19.5908 4.57001 18.5408 4.17001ZM12.0008 16.25C9.38078 16.25 7.25078 14.12 7.25078 11.5C7.25078 8.88001 9.38078 6.75001 12.0008 6.75001C14.6208 6.75001 16.7508 8.88001 16.7508 11.5C16.7508 14.12 14.6208 16.25 12.0008 16.25Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M15.4489 9.61113C15.2964 8.54821 14.4534 7.7053 13.3905 7.5528V9.61113H15.4489ZM15.8202 10.3053H13.0427C12.851 10.3053 12.6952 10.1503 12.6952 9.95819V7.18027C12.6952 6.98861 12.851 6.83319 13.0427 6.83319C14.7656 6.83319 16.1677 8.23527 16.1677 9.95819C16.1677 10.1503 16.0119 10.3053 15.8202 10.3053ZM12.3902 10.9909H15.7856C16.0115 10.9909 16.1881 11.1876 16.1656 11.4121C15.939 13.673 13.909 15.403 11.5348 15.1405C9.62438 14.9296 8.07146 13.3767 7.86021 11.4663C7.59854 9.09214 9.32771 7.06173 11.589 6.83548C11.814 6.81298 12.0102 6.98923 12.0102 7.21506V10.6113C12.0102 10.8209 12.1802 10.9909 12.3902 10.9909Z",
          fill: "#231F20"
        }
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: _vm.maskId,
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "6",
            width: "10",
            height: "10"
          }
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d:
                "M15.4489 9.61113C15.2964 8.54821 14.4534 7.7053 13.3905 7.5528V9.61113H15.4489ZM15.8202 10.3053H13.0427C12.851 10.3053 12.6952 10.1503 12.6952 9.95819V7.18027C12.6952 6.98861 12.851 6.83319 13.0427 6.83319C14.7656 6.83319 16.1677 8.23527 16.1677 9.95819C16.1677 10.1503 16.0119 10.3053 15.8202 10.3053ZM12.3902 10.9909H15.7856C16.0115 10.9909 16.1881 11.1876 16.1656 11.4121C15.939 13.673 13.909 15.403 11.5348 15.1405C9.62438 14.9296 8.07146 13.3767 7.86021 11.4663C7.59854 9.09214 9.32771 7.06173 11.589 6.83548C11.814 6.81298 12.0102 6.98923 12.0102 7.21506V10.6113C12.0102 10.8209 12.1802 10.9909 12.3902 10.9909Z",
              fill: "white"
            }
          })
        ]
      ),
      _c("g", { attrs: { mask: "url(#" + _vm.maskId + ")" } }, [
        _c("rect", {
          attrs: { x: "7", y: "6", width: "10", height: "10", fill: "white" }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }